export default import.meta.ROLLDOWN_FILE_URL_sMFBdU98uA5J8YzXkdYieg